import React from "react";

export default function AnalyticsChartCard({
  title,
  headerRight,
  footer,
  children,
  cardClassName = "card card101",
  wrapCol = true,
}) {
  const card = (
    <div className={cardClassName}>
      <div className="row">
        <div className="pull-left col col-12 col-sm-12 col-lg-7">
          <h3 className="card-title">{title}</h3>
        </div>
        <div className="col col-12 col-sm-12 col-lg-5">{headerRight}</div>
      </div>
      <div className="card-body p-3 text-center">{children}</div>
      {footer}
    </div>
  );

  if (!wrapCol) {
    return card;
  }

  return <div className="col col-12 col-sm-12 col-lg-12">{card}</div>;
}
